import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'highlight'})
export class HighlightPipe implements PipeTransform {

  transform(value: string, termsToHighlight: string) {
    //console.log("highlight:" + value + "/" + termsToHighlight);
    let terms = termsToHighlight.split(" ");
    terms.sort(function (a, b) {
      return b.length - a.length;
    });
    //console.log("terms:"+ terms);
    // Regex to simultaneously replace terms
    var regex = new RegExp('(' + terms.join('|') + ')', 'ig');
    let result = value.replace(regex, '<span class="highlightedText">$&</span>');
    //console.log("hightlight:" + result);
    return result;
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/common/utils/highlight/resource.highlight.pipe.ts